import ChatDetailCall from './ChatDetailCall';

export default ChatDetailCall;
